export const state = {
    showAdvancedSearch: false,
    parcelVector: null,
    cadastralRealEstate: null
};

export default state;
